var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 393.6 579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.5,202.2c-3,118.5-101.1,295.9-172.6,367.4-13,13-34.3,12.6-46.9-.9C107.5,497.9,3,328.8,0,202.2v-5.5C0,88,88.1-.1,196.8-.1s196.8,88.1,196.8,196.8,0,3.7,0,5.5h0ZM74.1,195.4c0,67.7,54.9,122.7,122.7,122.7s122.7-54.9,122.7-122.7-54.9-122.7-122.7-122.7-122.7,54.9-122.7,122.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.c96845a944ba4513f5792b4303d29210.svg";
export { ForwardRef as ReactComponent };